import axios from "axios";
import { ajaxUri } from "../../../consts/index";
import { l } from "../../../functions";

export const fetchProducts = (loadIncrement = null) => {
  return (dispatch) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "listProducts",
      },
    })
      .then((result) => {
        if (loadIncrement)
          dispatch({ type: "LOAD_INCREMENT", toAdd: parseInt(loadIncrement) });

        dispatch({ type: "LIST_PRODUCTS", products: result.data });
      })
      .catch((error) => {
        console.error(l("Cannot fetch products"));
      });
  };
};
